module.exports = __webpack_public_path__ + "static/media/phone.5bf88625.svg";